export default {
  common: {
    account: 'Conta',
    agents: 'Agentes',
    all: 'Tudo',
    available: 'Disponível',
    cancel: 'Cancelar',
    cloud: 'Nuvem',
    copy: 'Copiar',
    current: 'atual',
    delete: 'Excluir',
    error: 'Erro',
    export: 'Exportar',
    help: 'Ajuda',
    home: 'Início',
    language: 'Idioma',
    links: 'Links',
    loading: 'carregando',
    local: 'Local',
    login: 'Entrar',
    logout: 'Sair',
    metadata: 'Metadados',
    more: 'Mais',
    name: 'Nome',
    never: 'Nunca',
    none: 'nenhum',
    notes: 'Notas',
    ok: 'Ok',
    open: 'Abrir',
    password: 'senha',
    project: 'projeto',
    projects: 'Projetos',
    publicLink: 'Link público',
    register: 'Registrar',
    remove: 'Remover',
    save: 'Salvar',
    search: 'Buscar',
    settings: 'Configurações',
    subscribe: 'Assinar',
    track: 'faixa',
    tracks: 'Faixas',
    unknown: 'Desconhecido',
    unknownArtist: 'Artista desconhecido',
    upload: 'Enviar',
    username: 'nome de usuário'
  },
  time: {
    day: 'dia',
    days: 'dias',
    daysAgo: (ctx) => {
      const count = Number(ctx.named('count'))
      return `há ${count} ${count === 1 ? 'dia' : 'dias'}`
    },
    hoursAgo: (ctx) => {
      const count = Number(ctx.named('count'))
      return `há ${count} ${count === 1 ? 'hora' : 'horas'}`
    },
    minutesAgo: (ctx) => {
      const count = Number(ctx.named('count'))
      return `há ${count} ${count === 1 ? 'minuto' : 'minutos'}`
    },
    rightNow: 'agora mesmo',
    duration: (ctx) => {
      const minutes = Number(ctx.named('minutes'))
      const seconds = Number(ctx.named('seconds'))
      const minuteLabel = minutes === 1 ? 'minuto' : 'minutos'
      const secondLabel = seconds === 1 ? 'segundo' : 'segundos'
      if (minutes > 0) return `${minutes} ${minuteLabel} ${seconds} ${secondLabel}`
      return `${seconds} ${secondLabel}`
    }
  },
  topBar: {
    accountFallback: 'Conta',
    storage: 'Armazenamento',
    language: 'Idioma'
  },
  commandPalette: {
    placeholder: 'Buscar faixas e projetos...',
    projects: 'Projetos',
    tracks: 'Faixas',
    pages: 'Páginas',
    noResults: 'Nenhum resultado encontrado',
    quickLinks: 'Links rápidos',
    page: {
      home: 'Início',
      account: 'Conta',
      agents: 'Agentes',
      links: 'Links',
      settings: 'Configurações',
      help: 'Ajuda'
    }
  },
  explorer: {
    searchTitle: 'Buscar',
    trackCount: (ctx) => {
      const count = Number(ctx.named('count'))
      return `${count} ${count === 1 ? 'faixa' : 'faixas'}`
    }
  },
  emptyState: {
    hello: 'olá',
    addTrack: 'Adicionar uma faixa',
    addTrackSubtitle: 'para começar',
    dragDrop: 'Arrastar e soltar',
    dragDropSubtitle: 'seus arquivos para enviar rápido',
    switchStorage: 'Alternar',
    switchStorageSubtitle: 'entre nuvem e local no menu superior',
    installAgent: 'Instalar agente',
    installAgentSubtitle: 'para enviar seus arquivos automaticamente',
    playTrack: 'Reproduzir uma faixa',
    playTrackSubtitle: 'abra o player inferior para usar efeitos',
    community: 'tem dúvidas? entre nas nossas comunidades no {discord} e {telegram}.'
  },
  create: {
    createProject: 'Criar projeto',
    uploadTrack: 'Enviar faixa',
    newProject: 'Novo projeto',
    artist: 'Artista',
    name: 'Nome',
    create: 'Criar',
    loading: 'Carregando...',
    uploadCover: 'Enviar capa'
  },
  upload: {
    ariaLabel: 'Enviar faixa',
    uploadTrack: 'Enviar faixa',
    analyzing: 'Analisando...',
    fileAdded: 'Arquivo "{name}" adicionado',
    fileReadError: 'Erro ao ler o arquivo.',
    errorWithMessage: 'Erro: {message}'
  },
  dragDrop: {
    dropToUpload: 'Solte para enviar',
    deleteDrop: 'Solte aqui para excluir a faixa para sempre'
  },
  project: {
    upload: 'Enviar',
    noTracks: 'Sem faixas',
    createdBy: 'criado por',
    trackSummary: (ctx) => {
      const count = Number(ctx.named('count'))
      return `${count} ${count === 1 ? 'faixa' : 'faixas'}, ${ctx.named('duration')}`
    },
    play: 'Reproduzir',
    pause: 'Pausar'
  },
  trackItem: {
    more: 'Mais',
    copyPublicLink: 'Copiar link público',
    savedLocally: 'Salvo localmente',
    saveLocal: 'Salvar no armazenamento local',
    saving: 'Salvando...',
    saveCloud: 'Salvar na nuvem',
    deleteTrack: 'Excluir faixa',
    moveUp: 'Mover para cima',
    moveDown: 'Mover para baixo',
    removeFromProject: 'Remover de {project}',
    moveToProject: 'Mover para projeto',
    currentProject: '(atual)',
    confirmDelete: 'Tem certeza de que deseja excluir esta faixa?',
    linkCopiedTitle: 'Link copiado',
    linkCopiedDescription: 'Link público copiado para a área de transferência'
  },
  trackView: {
    created: 'criado {time}',
    tabs: {
      notes: 'Notas',
      metadata: 'Metadados'
    },
    notFound: 'faixa não encontrada ou indisponível para você',
    untitled: 'Sem título'
  },
  notes: {
    placeholder: 'Adicione notas sobre esta faixa...',
    saving: 'Salvando...',
    saveError: 'Não foi possível salvar as notas. Tente novamente.'
  },
  metadata: {
    trackOrder: 'Ordem da faixa',
    artist: 'Artista',
    name: 'Nome',
    key: 'Tom',
    mode: 'Modo',
    deleteTrack: 'Excluir faixa',
    saveError: 'Não foi possível salvar os metadados. Tente novamente.'
  },
  lufs: {
    momentary: 'LUFS momentâneo',
    shortTerm: 'LUFS de curto prazo',
    integrated: 'LUFS integrado'
  },
  effects: {
    pitchshift: 'Mudança de pitch',
    speed: 'Velocidade',
    balance: 'Balanço',
    volume: 'Volume',
    reverberation: 'Reverberação',
    distortion: 'Distorção',
    bitcrush: 'Bitcrush',
    saveCurrentEffectsAs: 'Salvar efeitos atuais como',
    presetName: 'Nome',
    add: 'Adicionar',
    availablePresets: 'Presets disponíveis',
    tune: 'Ajuste',
    eq: 'EQ',
    fx: 'FX',
    presets: 'Presets',
    center: 'Centro',
    left: 'Esquerda',
    right: 'Direita'
  },
  exportPanel: {
    applyEffects: 'Aplicar efeitos atuais',
    applyEffectsSubtitle: 'Exportar faixa com os efeitos atuais aplicados',
    exportWav: 'Exportar como WAV',
    exportMp3: 'Exportar como MP3',
    exporting: 'Exportando...',
    exportAsNewTrack: 'Exportar como nova faixa',
    creatingTrack: 'Criando faixa...',
    downloadOriginal: 'Baixar original',
    originalUnavailable: 'O arquivo original não está disponível.',
    downloadOriginalFailed: 'Não foi possível baixar o arquivo original.',
    exportAudioFailed: 'Não foi possível exportar o áudio da faixa.',
    waveformFailed: 'Não foi possível gerar a forma de onda.',
    createTrackFailed: 'Não foi possível criar a faixa exportada.',
    createTrackAlert: 'Não foi possível criar a faixa exportada: {message}',
    exportedSuffix: ' (exportação)',
    copySuffix: ' (cópia)'
  },
  publicLink: {
    copy: 'Copiar',
    open: 'Abrir',
    linkCopiedTitle: 'Link copiado',
    linkCopiedDescription: 'Link público copiado para a área de transferência'
  },
  settings: {
    tabs: {
      settings: 'Configurações',
      account: 'Conta',
      links: 'Links',
      agents: 'Agentes'
    },
    display: 'Exibição',
    language: 'Idioma',
    showBpm: 'Mostrar BPM na visualização da faixa',
    showBpmSubtitle: 'Mostra batidas por minuto de cada faixa na lista',
    showLufs: 'Mostrar LUFS na visualização da faixa',
    showLufsSubtitle: 'Mostra unidades de loudness de cada faixa na lista',
    showKey: 'Mostrar tom na visualização da faixa',
    showKeySubtitle: 'Mostra tom e modo de cada faixa na lista',
    playback: 'Reprodução',
    liveLoudness: 'Medição de loudness ao vivo',
    liveLoudnessSubtitle: 'Mostra o medidor de loudness ao vivo na tela do player',
    persistEffects: 'Manter efeitos aplicados para todas as faixas',
    persistEffectsSubtitle: 'Mantém os efeitos aplicados mesmo ao trocar de faixa',
    keyboardShortcuts: 'Atalhos de teclado',
    search: 'Buscar',
    pressShortcut: 'Pressione a combinação desejada',
    storage: 'Armazenamento',
    resetPresetsInfo: 'Redefinir todos os presets salvos neste navegador',
    resetPresets: 'Redefinir presets',
    resetAllWarning: 'Atenção! O botão abaixo exclui todos os dados do seu armazenamento local.',
    resetAllData: 'Redefinir armazenamento local e excluir todas as faixas e projetos',
    loadingAccount: 'Carregando conta...',
    loadingLinks: 'Carregando links...',
    loadingAgents: 'Carregando agentes...',
    authPrompt: 'Entre ou registre-se para usar esta seção.',
    loginRegister: 'Entrar ou registrar',
    pageTitle: {
      settings: 'configurações',
      account: 'configurações da conta',
      links: 'links públicos',
      agents: 'agentes'
    },
    presetsCleared: 'Armazenamento de presets limpo',
    localDataDeleted: 'Todos os dados locais excluídos',
    linkCopied: 'Link copiado',
    linkCopyFailed: 'Não foi possível copiar o link'
  },
  account: {
    hello: 'Olá {name}.',
    subscriptionStatus: 'Sua assinatura está {status} agora',
    noSubscription: 'Você não tem assinatura ativa.',
    manageSubscription: 'Gerenciar assinatura e métodos de pagamento',
    subscribeCloud: 'Assinar para usar a nuvem',
    changeUsername: 'Alterar nome de usuário',
    changePassword: 'Alterar senha',
    saveUsername: 'Salvar usuário',
    savePassword: 'Salvar senha',
    newPassword: 'nova senha',
    confirmPassword: 'confirmar senha',
    usernamePlaceholder: 'seu nome de usuário',
    storageUsage: 'Uso de armazenamento',
    baseStorage: 'Armazenamento base',
    subscriptionStorage: 'Armazenamento da assinatura',
    used: 'Usado',
    available: 'Disponível',
    deletedFilesNotice: 'Se você excluiu arquivos recentemente, eles ainda podem aparecer nestas métricas. Isso mudará em algumas horas.',
    accountId: 'id da conta',
    currentPeriodEnds: (ctx) => `o período de pagamento atual termina em ${ctx.named('count')} ${ctx.named('label')}`,
    accessEnds: (ctx) => `o acesso da assinatura termina em ${ctx.named('count')} ${ctx.named('label')}`,
    lastPaymentEnded: (ctx) => `o último período de pagamento terminou em ${ctx.named('date')}`,
    previousBillingDate: 'a data de cobrança anterior',
    billingPortalError: 'Erro no portal de cobrança',
    billingPortalFailed: 'Não foi possível abrir o portal de cobrança.',
    loginRequiredUpdate: 'Você precisa estar logado para atualizar seu perfil.',
    usernameEmpty: 'O nome de usuário não pode ficar vazio.',
    usernameUnchanged: 'O nome de usuário não foi alterado.',
    usernameUpdated: 'Nome de usuário atualizado',
    usernameUpdateFailed: 'Não foi possível atualizar o nome de usuário. Tente novamente.',
    passwordEmpty: 'A senha não pode ficar vazia.',
    passwordsMismatch: 'As senhas não coincidem.',
    passwordUpdated: 'Senha atualizada',
    passwordUpdateFailed: 'Não foi possível atualizar a senha. Tente novamente.'
  },
  links: {
    title: 'Links públicos',
    description: 'Todos os seus links públicos aparecem aqui. Qualquer pessoa com acesso pode ouvir o projeto ou a faixa.',
    cloudOnly: 'Links públicos só estão disponíveis no modo nuvem. Mude para armazenamento na nuvem para criar e gerenciar links públicos.',
    noLinks: 'Nenhum link público disponível',
    createFirst: 'Crie seu primeiro link público para começar a compartilhar.',
    confirmDelete: 'Tem certeza de que deseja excluir este link?',
    notFoundTitle: 'Link não encontrado ou expirado',
    notFoundDescription: 'O link que você está tentando acessar é inválido ou expirou.',
    unknownUser: 'desconhecido'
  },
  agents: {
    authorizeTitle: 'Autorizar agente',
    authorizeDescription: 'Permita que este agente se conecte à sua conta.',
    loginToAuthorize: 'Entre para autorizar este agente.',
    wantsConnect: 'Este agente quer se conectar à sua conta para enviar arquivos de áudio automaticamente.',
    permissionUpload: 'Enviar faixas',
    permissionMetadata: 'Criar metadados de faixas',
    authorize: 'Autorizar',
    cancel: 'Cancelar',
    authorizedTitle: 'Agente autorizado',
    authorizedDescription: 'Agora você pode fechar esta janela e voltar para o aplicativo do agente.',
    desktopTitle: 'Agente desktop',
    installDescription: 'Instale o agente demoparty no seu PC ou Mac para enviar automaticamente seus renders recentes.',
    warningLabel: 'AVISO: ',
    alphaWarning: 'o agente está em estado alpha e pode ser instável.',
    downloadMacApple: 'Baixar para Mac com Apple Silicon',
    downloadMacIntel: 'Baixar para Mac com Intel',
    downloadWindows: 'Baixar para Windows x64',
    signingNotice: 'Essas builds não são assinadas digitalmente porque o projeto ainda está em desenvolvimento. Avisos de segurança ao abrir são esperados. Builds assinadas serão fornecidas depois.',
    activeTitle: 'Agentes ativos',
    connectedDescription: 'Agentes conectados à sua conta.',
    loginToManage: 'Entre para gerenciar seus agentes.',
    noAgents: 'Ainda não há agentes conectados.',
    lastUsed: 'Último uso',
    revoke: 'Revogar',
    remove: 'Remover',
    confirmRemove: 'Tem certeza de que deseja remover este agente?',
    authorizeFailed: 'Não foi possível autorizar o agente. Tente novamente.'
  },
  login: {
    intro: 'Você precisa entrar se quiser usar recursos de nuvem e benefícios da assinatura. Caso contrário, pode usar o serviço localmente de graça.',
    subscriptionBenefits: 'benefícios da assinatura',
    login: 'Entrar',
    register: 'Registrar',
    forgot: 'Esqueci minha senha',
    email: 'e-mail',
    password: 'senha',
    repeatPassword: 'repetir senha',
    or: 'ou',
    google: 'Entrar com Google',
    apple: 'Entrar com Apple',
    resetPassword: 'Redefinir senha',
    resetDescription: 'Enviaremos um link de login para você definir uma nova senha.',
    sendResetLink: 'Enviar link de redefinição',
    invalidToken: 'Token inválido ou expirado',
    enterEmail: 'Digite seu e-mail',
    resetSent: 'Se a conta existir, enviamos um link de login para seu e-mail.',
    resetFailed: 'Não foi possível enviar o link. Tente novamente.'
  },
  googleCallback: {
    wait: 'Aguarde, estamos fazendo login...'
  },
  subscribe: {
    cloudRequiredTitle: 'Armazenamento em nuvem obrigatório',
    cloudRequiredMessage: 'Este recurso só está disponível com armazenamento em nuvem e assinatura ativa.',
    title: 'Comece local. Atualize para auto-upload.',
    description: 'A nuvem oferece uma biblioteca sincronizada entre dispositivos.',
    localFree: 'Você pode usar o app gratuitamente no modo local.',
    cloudIncludes: 'A nuvem inclui',
    featureLibrary: 'Uma biblioteca sincronizada entre web e iPhone',
    featureAgent: 'Auto-upload pelo agente desktop para renders recentes',
    featureStorage: '100 GB de armazenamento em nuvem para faixas',
    featureLinks: 'Links públicos persistentes para faixas e projetos',
    featureTools: 'Todas as ferramentas locais de análise, efeitos e exportação incluídas',
    monthly: 'Mensal',
    monthlyDescription: 'Sincronização na nuvem, cancele quando quiser',
    yearly: 'Anual',
    yearlyDescription: 'Melhor custo-benefício para sincronização na nuvem',
    saveTen: 'Economize 10%',
    perMonth: '/mês',
    billedMonthly: 'Cobrado mensalmente',
    billedYearly: '$53.89 cobrados anualmente',
    openingCheckout: 'Abrindo checkout...',
    subscribePlan: 'Assinar {plan}',
    registerSubscribe: 'Registrar e assinar',
    securePayment: 'Pagamento seguro via Polar. Cancele quando quiser nas configurações da conta.',
    customPlan: 'Precisa de um plano personalizado ou tem dúvidas? Fale conosco em',
    privacy: 'Política de Privacidade',
    terms: 'Termos de Serviço',
    refund: 'Política de Reembolso',
    checkoutFailed: 'Não foi possível criar o checkout. Tente novamente.'
  },
  thanks: {
    title: 'Obrigado pela assinatura!',
    description: 'Agora você pode usar armazenamento em nuvem. Para gerenciar sua assinatura, confira a página da conta.',
    startWorking: 'Começar a trabalhar',
    communities: 'Entre nas nossas comunidades',
    support: 'Se tiver problemas, fale conosco em {email} ou usando os links da comunidade acima.'
  },
  help: {
    title: 'Ajuda',
    intro: 'demoparty é um espaço de trabalho para músicas inacabadas e projetos em andamento. Ele permite armazenar demos, aplicar efeitos, editar tags e acompanhar metadados técnicos. O uso local é totalmente gratuito.',
    uploadTitle: 'Upload',
    uploadText: 'Você pode adicionar uma faixa clicando no botão Add na página principal. Durante o upload, o sistema detecta automaticamente tom, BPM e LUFS. Quando o upload terminar, você receberá uma notificação de confirmação.',
    storageTitle: 'Armazenamento',
    storageText: 'demoparty oferece duas opções de armazenamento: local e nuvem.',
    localStorageText: 'O armazenamento local mantém todos os dados apenas no seu dispositivo. Faixas e projetos ficam disponíveis somente no navegador onde foram enviados. IndexedDB é usado para armazenamento. Não é necessário registro e nenhum dado é enviado.',
    cloudStorageText: 'O armazenamento em nuvem mantém seus dados nos servidores da demoparty. Você pode acessar suas faixas de qualquer lugar a qualquer momento. Registro e assinatura ativa são necessários.',
    agentsTitle: 'Agentes',
    agentsText: 'Ao usar armazenamento em nuvem, você pode instalar um agente desktop. O agente envia automaticamente novas renderizações para a nuvem.',
    publicLinksTitle: 'Links públicos',
    publicLinksText: 'Usuários da nuvem podem criar links públicos para faixas e projetos. Na página do projeto, clique no botão de link. Para faixas, use o mesmo ícone no menu da faixa. Todos os links gerados podem ser gerenciados em Configurações.',
    exportTitle: 'Exportar',
    exportText: 'Faixas podem ser exportadas com todos os efeitos aplicados. Abra a página da faixa e selecione Exportar. Você pode baixar o arquivo original ou exportá-lo como MP3 ou WAV.',
    supportTitle: 'Suporte',
    supportText: "Para questões relacionadas a assinaturas da nuvem demoparty, fale conosco em support{'@'}demoparty.app.",
    attributionsTitle: 'Atribuições',
    attributionsText: 'As bibliotecas a seguir tornaram este projeto possível. O crédito pertence aos seus respectivos desenvolvedores.'
  },
  cover: {
    upload: 'Enviar capa',
    change: 'Alterar capa',
    delete: 'Excluir capa',
    loading: 'Carregando...',
    selectImage: 'Selecione um arquivo de imagem',
    uploadError: 'Erro ao enviar a capa'
  }
}
